import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import mutator from 'mutator';

export default graphql(
  gql`
    mutation DeleteAnnualTicket($id: Int!) {
      deleteAnnualTicket(id: $id)
    }
  `,
  {
    props: ({ mutate }) => ({
      deleteAnnualTicket: async (id) => {
        return mutator(() =>
          mutate({
            variables: { id },
            refetchQueries: ['GetAllAnnualTickets'],
          })
        );
      },
    }),
  }
);
